import qs from "qs";
import type { FetchOptions as OFetchOptions } from 'ofetch';

interface FetchOptions extends OFetchOptions {
    baseURL?: string;
    params?: Record<string, any>;
    server?: boolean;
    useSanctum?: boolean;
}

export default async (url: string, options: FetchOptions | undefined = undefined) => {
    // Destructure options to separate params and other fetch options
    const config = useRuntimeConfig();
    let baseURL, params, useSanctum, rest;

    if (typeof options !== 'undefined') {
        ({ baseURL, params, useSanctum, ...rest } = options);
    }

    const API_URL = baseURL ?? config.public.apiBase;

    // Stringify the params using qs
    const queryString = qs.stringify(params, { encodeValuesOnly: true });

    // Construct the full URL with query string
    const fullUrl = queryString ? `${url}?${queryString}` : url;

    const pack_options = {
        baseURL: API_URL,
        ...rest,
    };

    // Check if method is POST and send request with auth sanctum
    if (useSanctum) {
        const client = useSanctumClient();
        return client(fullUrl, pack_options);
    }

    // Use the standard useFetch method with the modified URL
    const result = await $fetch(fullUrl, {
        credentials: "include",
        ...pack_options,
    });

    return result;
};